import { AppointmentPhase } from "components";
import { DetailSectionTemplate } from "components/MainSectionTemplate/DetailSectionTemplate";
import { ArtistSidePanel } from "components/SidePanel/Company/CompanySidePanel";
import { LastRefreshDotLabel } from "externalCalendar/LastRefreshDotLabel";
import React from "react";
import ShowDateTime from "show/components/ShowDateTime";
import { replaceNewLineWithBr } from "utilities/reactUtils";
import { routes } from "utilities/routing/generatedRoutes";

interface ExternalEventDetailSectionProps {
  externalEvent: server.dto.ExternalEvent
  externalCalendar: server.dto.ExternalCalendar
}

export const ExternalEventDetailSection = (props: ExternalEventDetailSectionProps) => {
  const { externalEvent, externalCalendar } = props;

  return <DetailSectionTemplate
    isInPageEditable={false}
    onValueChanged={() => { }}
    sections={[{
      type: "regular",
      key: "externalEvent",
      title: RESX.ExternalCalendar.ExternalEvent,
      fields: [{
        key: "artist",
        label: site.currentEnvironment.functionGroups.artist.singular,
        render: () => <ArtistSidePanel
          companyId={externalEvent.artist.artistId}
          trigger={<a>{externalEvent.artist.name}</a>}
          fallbackIfNoPermission={<>{externalEvent.artist.name}</>}
        />,
      }, {
        key: "date",
        label: RESX.DateTime.lblDate,
        render: () => <ShowDateTime dateTime={externalEvent.dateTime} />,
      }, {
        key: "status",
        label: RESX.Status.resxStatus,
        render: () => <AppointmentPhase value={externalEvent.phase} displayLabel />,
      }, {
        key: "externalCalendar",
        label: RESX.ExternalCalendar.resxExternalCalendar,
        render: () => <div>
          <a href={routes.externalCalendar_Detail(externalCalendar.externalCalendarId).absolute}>
            {externalCalendar.title}
          </a>
          <LastRefreshDotLabel item={externalCalendar} />
        </div>
      }, {
        key: "summary",
        label: RESX.GeneralLabels.Summary,
        render: () => <div>{externalEvent.summary}</div>
      }, {
        key: "location",
        label: RESX.Planning.Location,
        isEmpty: !externalEvent.location,
        render: () => <div>{externalEvent.location}</div>
      }, {
        key: "description",
        label: RESX.GeneralLabels.Description,
        isEmpty: !externalEvent.content,
        render: () => externalCalendar.type === "googleCalendar" ? <div
          dangerouslySetInnerHTML={{
            __html: externalEvent.content
          }}
        /> : <div>{replaceNewLineWithBr(externalEvent.content)}</div>
      }]
    }]}
  />
}